import { Button, Form, Input, message, Modal, Typography } from 'antd'
import api from 'api'
import { useTranslation } from 'next-i18next'
import { Dispatch, FC, useCallback } from 'react'
import { KeyedMutator } from 'swr'

type Props = {
  visible: boolean
  setVisible: Dispatch<boolean>
  ownerId: string
  user?: User
  mutateCustomer: KeyedMutator<boolean>
  afterFinish?: any
}

export const SimpleCustomerForm: FC<Props> = ({
  visible,
  setVisible,
  ownerId,
  user,
  mutateCustomer,
  afterFinish,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const onFinish = useCallback(
    async (values: any) => {
      const { data, error }: { data: any; error: any } = await api.post(
        '/customers',
        {
          ...values,
          owner_id: ownerId,
        },
      )
      if (data) {
        message.success(t('登録が完了しました'))
        mutateCustomer()
        afterFinish && afterFinish()
      }
      if (error) {
        message.error(error.data.error)
      }
    },
    [afterFinish, mutateCustomer, ownerId, t],
  )

  const onFinishFailed = useCallback(() => {
    message.error(t('入力内容に不備があります'))
  }, [t])

  return (
    <Modal
      title={
        <Typography.Text
          style={{ fontSize: '16px', lineHeight: 1.5, fontWeight: 700 }}
        >
          {t('登録')}
        </Typography.Text>
      }
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={null}
    >
      <Form
        layout="vertical"
        requiredMark={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
        initialValues={{
          first_name: user?.first_name,
          last_name: user?.last_name,
          email: user?.email,
          phone_numbers_attributes: [
            {
              is_default: true,
              label: '携帯',
              phone_number: user?.phone_number,
            },
          ],
        }}
      >
        <Form.Item label={t('姓名')} style={{ marginBottom: 0 }}>
          <Form.Item
            name="last_name"
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
            rules={[
              {
                required: true,
                message: t('姓を入力してください'),
              },
            ]}
          >
            <Input placeholder={t('姓')} />
          </Form.Item>
          <Form.Item
            name="first_name"
            style={{
              display: 'inline-block',
              width: '50%',
              margin: '0 0 0 8px',
            }}
            rules={[
              {
                required: true,
                message: t('名を入力してください'),
              },
            ]}
          >
            <Input placeholder={t('名')} />
          </Form.Item>
        </Form.Item>

        <Form.Item label={t('フリガナ')} style={{ marginBottom: 0 }}>
          <Form.Item
            name="last_name_kana"
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Input placeholder={t('セイ')} />
          </Form.Item>

          <Form.Item
            name="first_name_kana"
            style={{
              display: 'inline-block',
              width: '50%',
              margin: '0 0 0 8px',
            }}
          >
            <Input placeholder={t('メイ')} />
          </Form.Item>
        </Form.Item>
        <Form.Item label={t('メールアドレス')} name="email">
          <Typography.Text>{user?.email}</Typography.Text>
        </Form.Item>

        <Form.Item
          name={['phone_numbers_attributes', '0', 'phone_number']}
          label={t('電話番号')}
          rules={[{ required: true, message: t('必須項目です') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name={['phone_numbers_attributes', '0', 'label']} hidden />
        <Form.Item
          name={['phone_numbers_attributes', '0', 'is_default']}
          hidden
        />

        <Form.Item>
          <Button type="primary" onClick={() => form.submit()}>
            {t('送信する')}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}
